import { defineComponent as _defineComponent } from 'vue'
import LotApproveButton from "@/components/Lot/LotApproveButton.vue";
  import ContactStatusBadge from "@/components/ui/ContactStatusBadge.vue";
  import { EoiGroupByLotInterface, EoiInterface } from "@/types/EoiInterface";
  import { EoiStatus } from "@/enums/EoiStatus";
  import { useStore } from "vuex";
  import {
    computed,
    onMounted,
    onUnmounted,
    ref,
    watch,
  } from "vue";
  import router from "@/router";
  import { getFirstLastName } from "@/helpers/user";
  import { getLandownerEoiStatus } from "@/helpers/eoi";
  import { lotRequestInterval } from "@/static/lot";
  import { EoiContractConditions } from "@/enums/EoiContractConditions";
  import CompletedResForm from "@/components/ui/modals/CompletedResForm.vue";
  import SendEoiDocumentsModal from "@/components/ui/modals/SendEoiDocumentsModal.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LotEoisRequests',
  emits: ["updateLot", "updateEoi"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const store = useStore();
  const emits = __emit;
  const lotId = router.currentRoute.value.params.lotId;
  const eois = ref<EoiGroupByLotInterface | null>(null);
  const openCompletedResForm = ref(false);
  const openSendEoiDocumentsModal = ref(false);
  const eoiId = ref("");
  const estateId = computed(() => {
    return store.state.user.selectedEstateId;
  });
  const isApprovLoading = ref(false);
  const isPaymentAllowed = ref(true);

  const isApproving = computed(() => {
    if (isApprovLoading.value) {
      return true;
    }

    for (const eoi of eois.value?.eois || []) {
      if (eoi.status === EoiStatus.WAITING_FOR_APPROVED) {
        return true;
      }
    }

    return false;
  });
  let timerId: number | undefined;

  watch(
    () => isApproving.value,
    (value, prevValue) => {
      if (value && value !== prevValue) {
        timerId = setInterval(onConfirm, lotRequestInterval);
      } else {
        clearInterval(timerId);
      }
    }
  );

  onMounted(() => {
    getEois();
    store.dispatch("appSettings/getAppSettings").then((res) => {
      isPaymentAllowed.value = res?.data?.isPaymentAllowed;
    });
  });
  onUnmounted(() => {
    clearInterval(timerId);
  });

  const onConfirm = (id: string) => {
    eoiId.value = id;
    getEois();
    emits("updateLot");
    emits("updateEoi");
    openCompletedResForm.value = true;
  };

  const closeCompletedResForm = () => {
    openCompletedResForm.value = false;
  };

  const getEois = () => {
    store
      .dispatch("eoi/getEoisForLot", {
        id: lotId,
        estateId: estateId.value,
        status: [
          EoiStatus.PENDING,
          EoiStatus.APPROVED,
          EoiStatus.DECLINED,
          EoiStatus.WAITING_FOR_APPROVED,
          EoiStatus.WAITING_FOR_DECLINED,
          EoiStatus.WITHDRAWN,
          EoiStatus.REFUNDED,
          EoiStatus.REFUND_DECLINED,
          EoiStatus.TRANSACTION_ERROR,
        ],
      })
      .then((res) => {
        eois.value = res.data;
        isApprovLoading.value = false;
      });
  };

  function lotInfo(eoi: EoiInterface) {
    return {
      lot: eois.value?.lot.title,
      name:
        eoi?.buyersData?.firstBuyer?.firstName +
        " " +
        eoi?.buyersData?.firstBuyer?.lastName,
      eoiId: eoi._id,
      lotId: lotId,
    };
  }
  function onRow(row: EoiInterface) {
    if (
      !isApproving.value ||
      row.status === EoiStatus.WAITING_FOR_APPROVED ||
      row.status === EoiStatus.WAITING_FOR_DECLINED
    ) {
      router.push(`/eoi/${row._id}`);
    }
  }

const __returned__ = { store, emits, lotId, eois, openCompletedResForm, openSendEoiDocumentsModal, eoiId, estateId, isApprovLoading, isPaymentAllowed, isApproving, get timerId() { return timerId }, set timerId(v) { timerId = v }, onConfirm, closeCompletedResForm, getEois, lotInfo, onRow, LotApproveButton, ContactStatusBadge, get EoiGroupByLotInterface() { return EoiGroupByLotInterface }, get EoiInterface() { return EoiInterface }, get EoiStatus() { return EoiStatus }, get useStore() { return useStore }, computed, onMounted, onUnmounted, ref, watch, get router() { return router }, get getFirstLastName() { return getFirstLastName }, get getLandownerEoiStatus() { return getLandownerEoiStatus }, get lotRequestInterval() { return lotRequestInterval }, get EoiContractConditions() { return EoiContractConditions }, CompletedResForm, SendEoiDocumentsModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})